import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import * as UseInvite from "./useInvite";

export function useDeclineInviteMutation() {
  const { inviteService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (inviteId) => {
      return inviteService.declineInvite(inviteId);
    },
    onSuccess() {
      return queryClient.invalidateQueries({
        queryKey: UseInvite.getQueryKey(),
      });
    },
  });
}
